export const getInspectionBudgetSelector = state => state?.inspectionBudget

export const getInspectionBudgetByIdSelector = state => state.inspectionBudget?.get('currentBudget')

export const getInspectionTradesmenSelector = state => state?.inspectionBudget?.tradesmen

export const getInspectionBudgetResolutionMaterialUnidsSelector = state =>
  state?.inspectionBudget?.materialUnids
